<p>item-list works!</p>
<div class="card">
  <div>[icon]</div>
  <div>[title]</div>
</div>
